// MarcaPadrao.js — a "foto" de quem não tem foto (18/10/2026, pedido do dono):
// a marca da Insigne num disco laranja. Preenche o contêiner (que já é
// recortado: redondo, ou a "mancha" dos cartões de autor; já com o tamanho
// certo em cada tela), então serve no avatar de
// 36px do comentário e no de 96px da página do autor.
//
// Substituiu os monogramas (iniciais sobre degradê ou sobre fundo navy) que
// cada tela desenhava do seu jeito: cartões de autores, home, página do
// autor, perfil, cabeçalho e comentários.
import React from "react";
import marca from "../../assets/imgs/logo (1).png";

const MarcaPadrao = ({ className = "", titulo }) => (
  <div
    className={"w-full h-full bg-insigne-orange flex items-center justify-center select-none " + className}
    title={titulo}
    aria-hidden={!titulo}
  >
    <img src={marca} alt="" className="w-[58%] h-auto" draggable="false" />
  </div>
);

export default MarcaPadrao;
